module.exports = __webpack_public_path__ + "annualreview2018/static/pdfs/sections--governance.e197ef8.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/sections--governance.pdf
// module id = ct/t
// module chunks = 10